import React, { useEffect, useState, useRef } from "react";
import {
    Grid, Button, IconButton, Typography, Box, Stack, Modal,
    Divider, CircularProgress, Paper, LinearProgress,
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import AddIcon from '@mui/icons-material/Add';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import YouTubeIcon from '@mui/icons-material/YouTube';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { useLocation, useNavigate } from "react-router-dom";
import RohanImg from '../../../assets/podcast_monster/rohan_png.png';
import { toast } from "react-toastify";
import axios from 'axios';

import { setCookie, getCookie, removeCookie } from '../../../utils/storageUtils';
import { useAppDispatch } from '../../../redux/store';
import { logout } from "redux/features/userSlice";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { usePlanDetailsMutation } from "../../../redux/api/productApi";
import { isMobile } from "react-device-detect";
import { useCourseJobTracker } from "hooks/useCourseJobTracker";

import '../generated_blogs.css';
import './CreateCourse.module.css';
import { redirectAfterLogout } from "../../../utils/logoutRedirect";

// ─────────────────────────────────────────────────────────────────────────────
// SIDEBAR NAV CONFIG
// ─────────────────────────────────────────────────────────────────────────────
const sidebarItems = [
    //{ id: "dashboard", label: "Dashboard",        icon: <DashboardOutlinedIcon sx={{ fontSize: 18 }} /> },
    { id: "authority", label: "Dashboard", icon: <AutoGraphOutlinedIcon sx={{ fontSize: 18 }} /> },
    { id: "mycourse",  label: "My Course",        icon: <SchoolOutlinedIcon    sx={{ fontSize: 18 }} /> },
];

const contentLibraryItems = [
    { id: "blogs",    label: "Blogs",        icon: <ArticleOutlinedIcon           sx={{ fontSize: 16 }} /> },
    { id: "episodes", label: "Episodes",     icon: <GraphicEqIcon                 sx={{ fontSize: 16 }} /> },
    { id: "clips",    label: "Clips",        icon: <PlayCircleOutlinedIcon        sx={{ fontSize: 16 }} /> },
    { id: "images",   label: "Images",       icon: <ImageOutlinedIcon             sx={{ fontSize: 16 }} /> },
    { id: "social",   label: "Social Posts", icon: <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 16 }} /> },
];

const bottomNav = [
    { id: "upgrade",  label: "Upgrade",  icon: <TrendingUpOutlinedIcon sx={{ fontSize: 18 }} /> },
    { id: "billing",  label: "Billing",  icon: <PaymentOutlinedIcon    sx={{ fontSize: 18 }} /> },
    { id: "payment",  label: "Payment",  icon: <PaymentOutlinedIcon    sx={{ fontSize: 18 }} /> },
    { id: "settings", label: "Settings", icon: <SettingsOutlinedIcon   sx={{ fontSize: 18 }} /> },
    { id: "logout",   label: "Logout",   icon: <LogoutOutlinedIcon     sx={{ fontSize: 18 }} /> },
];

// ─────────────────────────────────────────────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const New_Course_2 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const { FromEdit } = location.state || {};
    const FromSignUp = location.state?.FromSignUp || '';

    const user_email = localStorage.getItem('user_email') || getCookie('user_email') || '';

    // ── State ──
    const [userDetails, setUserDetails] = useState<any>();
    const [planDetails, setPlanDetails] = useState<any>();
    const [activeItem, setActiveItem]   = useState(localStorage.getItem('activeItem') || 'createcourse');
    const [contentLibOpen, setContentLibOpen] = useState(true);
    const [showSuccess, setShowSuccess]       = useState(false);
    const [upgradeModal, setUpgradeModal]     = useState<boolean>(false);
    const [openpaymentInstructModal, setOpenPaymentInstructModal] = useState<boolean>(false);

    // ── Job tracking ──
    const jobData = useCourseJobTracker();
    const [CJBprogress, setCJBProgress] = useState(1);
    const [progress, setProgress]       = useState(10);
    const [jobId, setJobId]             = useState<string | null>(null);
    const pushCalledRef                 = useRef(false);

    // ── RTK mutations ──
    const [getUserDetailsMutation] = useGetUserDetailsMutation();
    const [getuserPlanDetails]     = usePlanDetailsMutation();

    // ─────────────────────────────────────────────────────────────────────
    // Lifecycle
    // ─────────────────────────────────────────────────────────────────────
    const fetchUserData = async () => {
        try {
            const response = await getUserDetailsMutation({
                email: user_email || getCookie('user_email') || '',
                filter: '', start_date: '', end_date: ''
            });
            if ('data' in response) setUserDetails(response.data.data);
        } catch (error) { console.log(error); }
    };

    const fetchPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({
                email: user_email || getCookie('user_email') || '', campaignid: ''
            });
            if ('data' in response) setPlanDetails(response.data.data);
        } catch (error) { console.log(error); }
    };

    useEffect(() => {
        fetchUserData();
        fetchPlanDatas();
    }, []);

    // ─────────────────────────────────────────────────────────────────────
    // Course generation: push to Weaviate
    // ─────────────────────────────────────────────────────────────────────
    const pushCoursesToWeaviate = async () => {
        try {
            const parentCourseId = localStorage.getItem("course_id");
            const userEmail = localStorage.getItem("user_email");
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || "";

            setProgress(50);

            const res = await axios.post(
                `${apiUrl}/api/prompts/push-courses?parent_course_id=${parentCourseId}&user_email=${userEmail}`
            );
            console.log('[CourseGen] push-courses response =>', res);

            const job_id = res?.data?.job_id;
            setJobId(job_id);
            localStorage.setItem("course_job_id", job_id);
        } catch (e) {
            console.error(e);
            toast.error("Failed to process uploaded content");
        }
    };

    useEffect(() => {
        if (pushCalledRef.current) return;
        pushCalledRef.current = true;
        pushCoursesToWeaviate();
    }, []);

    // ─────────────────────────────────────────────────────────────────────
    // Progress ticker
    // ─────────────────────────────────────────────────────────────────────
    useEffect(() => {
        const interval = setInterval(() => {
            setCJBProgress((prev: number) => (prev >= 98 ? prev : prev + 1));
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (jobData?.progress != null) {
            setCJBProgress((prev: number) => Math.max(prev, jobData.progress));
        }
    }, [jobData]);

    useEffect(() => {
        if (jobData?.status === "completed") {
            setProgress(100);
            setCJBProgress(100);
            const timer = setTimeout(() => setShowSuccess(true), 2000);
            return () => clearTimeout(timer);
        }
    }, [jobData]);

    // ─────────────────────────────────────────────────────────────────────
    // Navigation handlers
    // ─────────────────────────────────────────────────────────────────────
    const handleCreateCourseStep2 = () => {
        navigate('/codegenie/generated-blogs');
        localStorage.removeItem('expertise');
    };

    const handleCreateCourseStepPrevious = () => {
        navigate('/codegenie/new-course-2-1',
            { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' } });
    };

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };

    const handleItemClick = (itemName: any) => {
        localStorage.setItem('activeItem', itemName);
        setActiveItem(itemName);

        if (itemName === 'dashboard')              navigate('/codegenie/dashboard');
        else if (itemName === 'authority')         navigate('/codegenie/authority-engine');
        else if (itemName === 'mycourse')          navigate('/codegenie/generated-courses');
        else if (itemName === 'course')            navigate('/codegenie/generated-courses');
        else if (itemName === 'blogs')             navigate('/codegenie/generated-blogs');
        else if (itemName === 'episodes')          navigate('/codegenie/generated-episodes');
        else if (itemName === 'clips')             navigate('/codegenie/generated-clips');
        else if (itemName === 'images')            navigate('/codegenie/generated-images');
        else if (itemName === 'social')            navigate('/codegenie/generated-social-posts');
        else if (itemName === 'digitaltwin')       navigate('/codegenie/digital-twin');
        else if (itemName === 'createcourse')      navigate('/codegenie/new-course-2-1');
        else if (itemName === 'upgrade') {
            localStorage.setItem('fromUpgrade', 'true');
            navigate('/pricing', { state: { from_page: 'blog_listing' } });
        }
        else if (itemName === 'billing')           navigate('/codegenie/billing');
        else if (itemName === 'payment')           navigate('/codegenie/payment');
        else if (itemName === 'settings')          navigate('/codegenie/settings');
        else if (itemName === 'logout') {
            clearCookies();
            localStorage.setItem("logged_in", "false");
            dispatch(logout());
            toast.success("Logout success");
            localStorage.clear();
            removeCookie('user_email');
            redirectAfterLogout(); //"https://ocesha.ai";
        }
    };

    // Success modal inline styles
    const styles = {
        overlay: {
            position: "fixed" as const, top: 0, left: 0,
            width: "100%", height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 9999, backdropFilter: "blur(5px)",
        },
        modal: {
            background: "linear-gradient(180deg, rgba(17,24,39,0.98) 0%, rgba(8,12,20,0.98) 100%)",
            padding: "32px", borderRadius: "16px",
            textAlign: "center" as const, width: "380px",
            border: "1px solid rgba(255,255,255,0.08)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
            color: "#fff",
        },
        primaryBtn: {
            background: "linear-gradient(135deg, #7C3AED, #6D28D9)",
            color: "#fff", border: "none",
            padding: "12px 14px", borderRadius: "10px",
            cursor: "pointer", fontWeight: 600, fontSize: "14px",
            transition: "all 0.2s ease",
        },
        secondaryBtn: {
            background: "rgba(255,255,255,0.06)",
            color: "rgba(255,255,255,0.85)",
            border: "1px solid rgba(255,255,255,0.12)",
            padding: "12px 14px", borderRadius: "10px",
            cursor: "pointer", fontWeight: 600, fontSize: "14px",
            transition: "all 0.2s ease",
        },
    };

    // ─────────────────────────────────────────────────────────────────────
    // RENDER
    // ─────────────────────────────────────────────────────────────────────
    return (
        <Box sx={{
            display: "flex",
            minHeight: "100vh",
            background: "#000000",
            color: "#fff",
            fontFamily: "'Inter', -apple-system, sans-serif",
        }}>

            {/* ═══════════════ SIDEBAR ═══════════════ */}
            <Box sx={{
                width: 260,
                flexShrink: 0,
                background: "linear-gradient(180deg, #0B1220 0%, #06080F 100%)",
                borderRight: "1px solid rgba(255,255,255,0.06)",
                display: { xs: "none", md: "flex" },
                flexDirection: "column",
                position: "sticky", top: 0,
                height: "100vh", overflowY: "auto",
            }}>

                {/* Logo */}
                <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2.5, pt: 2.5, pb: 2 }}>
                    <Typography sx={{ fontSize: 22, fontWeight: 800, color: "#fff", letterSpacing: 1 }}>
                        OCESHA
                    </Typography>
                    <YouTubeIcon sx={{ color: "#FF0000", fontSize: 22 }} />
                </Stack>

                {/* AI Digital Twin card */}
                <Box sx={{
                    mx: 2, mb: 2, p: 1.5, borderRadius: "12px",
                    background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)",
                    border: "1px solid rgba(255,255,255,0.06)",
                }}>
                    <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.45)", letterSpacing: 1, fontWeight: 600, mb: 1 }}>
                        AI DIGITAL TWIN
                    </Typography>
                    <Stack direction="row" spacing={1.2} alignItems="center" mb={1.5}>
                        <Box component="img" src={RohanImg} sx={{
                            width: 36, height: 36, borderRadius: "50%", objectFit: "cover",
                        }} />
                        <Box>
                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#fff" }}>
                                Rohan Hall
                            </Typography>
                            <Stack direction="row" spacing={0.5} alignItems="center">
                                <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E" }} />
                                <Typography sx={{ fontSize: 11, color: "rgba(255,255,255,0.55)" }}>
                                    AI Twin Online
                                </Typography>
                            </Stack>
                        </Box>
                    </Stack>
                    <Stack direction="row" alignItems="center" sx={{
                        background: "rgba(255,255,255,0.04)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        borderRadius: "8px", px: 1.2, py: 0.6,
                    }}>
                        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.5)", flex: 1 }}>
                            Ask My AI Twin
                        </Typography>
                        <ChatBubbleOutlineOutlinedIcon sx={{ fontSize: 14, color: "rgba(255,255,255,0.5)" }} />
                    </Stack>
                </Box>

                {/* Main nav */}
                <Stack spacing={0.4} sx={{ px: 1.5 }}>
                    {sidebarItems.map((item) => {
                        const active = activeItem === item.id;
                        return (
                            <Stack key={item.id} direction="row" spacing={1.2} alignItems="center"
                                onClick={() => handleItemClick(item.id)}
                                sx={{
                                    cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
                                    background: active ? "linear-gradient(90deg, #0168B5 0%, #4BA5EB 100%)" : "transparent",
                                    color: active ? "#fff" : "rgba(255,255,255,0.7)",
                                    "&:hover": { background: active ? undefined : "rgba(255,255,255,0.04)" },
                                }}>
                                {item.icon}
                                <Typography sx={{ fontSize: 13.5, fontWeight: active ? 600 : 500 }}>
                                    {item.label}
                                </Typography>
                            </Stack>
                        );
                    })}

                    {/* Content Library */}
                    <Box>
                        <Stack direction="row" spacing={1.2} alignItems="center"
                            onClick={() => setContentLibOpen((v) => !v)}
                            sx={{
                                cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
                                color: "rgba(255,255,255,0.7)",
                                "&:hover": { background: "rgba(255,255,255,0.04)" },
                            }}>
                            <FolderOutlinedIcon sx={{ fontSize: 18 }} />
                            <Typography sx={{ fontSize: 13.5, fontWeight: 500, flex: 1 }}>
                                Content Library
                            </Typography>
                            {contentLibOpen ? <KeyboardArrowUpIcon sx={{ fontSize: 16 }} /> : <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
                        </Stack>

                        {contentLibOpen && (
                            <Stack spacing={0.3} sx={{ ml: 3, mt: 0.3 }}>
                                {contentLibraryItems.map((item) => {
                                    const active = activeItem === item.id;
                                    return (
                                        <Stack key={item.id} direction="row" spacing={1} alignItems="center"
                                            onClick={() => handleItemClick(item.id)}
                                            sx={{
                                                cursor: "pointer", px: 1.2, py: 0.7, borderRadius: "7px",
                                                color: active ? "#4BA5EB" : "rgba(255,255,255,0.6)",
                                                background: active ? "rgba(75,165,235,0.08)" : "transparent",
                                                "&:hover": { background: "rgba(255,255,255,0.03)" },
                                            }}>
                                            {item.icon}
                                            <Typography sx={{ fontSize: 12.5 }}>{item.label}</Typography>
                                        </Stack>
                                    );
                                })}
                            </Stack>
                        )}
                    </Box>

                    <Stack direction="row" spacing={1.2} alignItems="center"
                        onClick={() => handleItemClick("digitaltwin")}
                        sx={{
                            cursor: "pointer", px: 1.5, py: 1, mt: 0.4, borderRadius: "8px",
                            color: activeItem === "digitaltwin" ? "#4BA5EB" : "rgba(255,255,255,0.7)",
                            background: activeItem === "digitaltwin" ? "rgba(75,165,235,0.08)" : "transparent",
                            "&:hover": { background: "rgba(255,255,255,0.04)" },
                        }}>
                        <SmartToyOutlinedIcon sx={{ fontSize: 18 }} />
                        <Typography sx={{ fontSize: 13.5, fontWeight: 500 }}>My Digital Twin</Typography>
                    </Stack>
                </Stack>

                <Divider sx={{ borderColor: "rgba(255,255,255,0.06)", my: 2, mx: 2 }} />

                {/* Bottom nav */}
                <Stack spacing={0.4} sx={{ px: 1.5, pb: 2 }}>
                    {bottomNav.map((item) => (
                        <Stack key={item.id} direction="row" spacing={1.2} alignItems="center"
                            onClick={() => handleItemClick(item.id)}
                            sx={{
                                cursor: "pointer", px: 1.5, py: 1, borderRadius: "8px",
                                color: "rgba(255,255,255,0.65)",
                                "&:hover": { background: "rgba(255,255,255,0.04)" },
                            }}>
                            {item.icon}
                            <Typography sx={{ fontSize: 13, fontWeight: 500 }}>{item.label}</Typography>
                        </Stack>
                    ))}
                </Stack>
            </Box>

            {/* ═══════════════ MAIN CONTENT ═══════════════ */}
            <Box sx={{ flex: 1, overflowY: "auto" }}>

                {/* TOP HEADER BAR */}
                <Stack direction="row" alignItems="center" justifyContent="space-between"
                    sx={{
                        px: { xs: 2, md: 3 }, py: 1.5,
                        borderBottom: "1px solid rgba(255,255,255,0.06)",
                        background: "rgba(0,0,0,0.4)",
                        position: "sticky", top: 0, zIndex: 10,
                        backdropFilter: "blur(10px)",
                    }}>
                    <Button
                        startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
                        onClick={() => handleItemClick('dashboard')}
                        sx={{
                            color: "rgba(255,255,255,0.75)", textTransform: "none",
                            fontSize: 13.5, fontWeight: 500,
                            "&:hover": { color: "#fff", background: "rgba(255,255,255,0.04)" },
                        }}>
                        Back to Dashboard
                    </Button>

                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        {/* <Button
                            startIcon={<AddIcon sx={{ fontSize: 16 }} />}
                            endIcon={<KeyboardArrowDownIcon sx={{ fontSize: 16 }} />}
                            sx={{
                                background: "linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)",
                                color: "#fff", textTransform: "none", borderRadius: "10px",
                                fontSize: 13, fontWeight: 600, px: 2, py: 0.8,
                                "&:hover": { background: "linear-gradient(135deg, #6D28D9 0%, #5B21B6 100%)" },
                            }}>
                            Create New
                        </Button> */}

                        <IconButton sx={{ position: "relative", color: "rgba(255,255,255,0.7)" }}>
                            <NotificationsNoneOutlinedIcon sx={{ fontSize: 22 }} />
                            <Box sx={{
                                position: "absolute", top: 6, right: 6,
                                width: 18, height: 18, borderRadius: "50%",
                                background: "#EF4444", color: "#fff",
                                fontSize: 10, fontWeight: 700,
                                display: "flex", alignItems: "center", justifyContent: "center",
                            }}>
                                3
                            </Box>
                        </IconButton>

                        <Box component="img" src={RohanImg} sx={{
                            width: 36, height: 36, borderRadius: "50%", objectFit: "cover",
                            border: "2px solid rgba(255,255,255,0.1)", cursor: "pointer",
                        }} />
                    </Stack>
                </Stack>

                {/* PAGE BODY */}
                <Box sx={{ p: { xs: 2, md: 3 } }}>

                    {/* ── PENDING PAYMENT BANNER ── */}
                    {planDetails?.payment_status === 'pending' && (
                        <Box sx={{
                            background: '#090619', borderRadius: '8px', p: 2, mb: 2,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1,
                        }}>
                            <InfoIcon sx={{ color: 'orange', fontSize: 22 }} />
                            <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#fff' }}>
                                Subscription is PENDING — please complete the payment.
                            </Typography>
                        </Box>
                    )}

                    {/* ── PAGE HEADER CARD ── */}
                    <Box sx={{
                        background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        borderRadius: "16px",
                        p: 3,
                        mb: 3,
                    }}>
                        <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between"
                            alignItems={{ xs: "flex-start", md: "center" }} spacing={2}>

                            <Stack direction="row" spacing={2} alignItems="center">
                                <Box sx={{
                                    width: 54, height: 54, borderRadius: "12px",
                                    background: "rgba(16,185,129,0.12)",
                                    border: "1px solid rgba(16,185,129,0.3)",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                }}>
                                    <SchoolOutlinedIcon sx={{ color: "#10B981", fontSize: 28 }} />
                                </Box>
                                <Box>
                                    <Typography sx={{
                                        color: "#10B981", fontSize: 11, fontWeight: 700,
                                        letterSpacing: 1.2, textTransform: "uppercase",
                                    }}>
                                        COURSE
                                    </Typography>
                                    <Typography sx={{ fontSize: 26, fontWeight: 700, color: "#fff", lineHeight: 1.2 }}>
                                        Generating Your Course
                                    </Typography>
                                    <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: 13.5, mt: 0.4 }}>
                                        We're putting together your course and marketing content. This will just take a few minutes.
                                    </Typography>
                                </Box>
                            </Stack>

                            <Box sx={{
                                background: "rgba(124,58,237,0.08)",
                                border: "1px solid rgba(124,58,237,0.25)",
                                borderRadius: "12px",
                                px: 2, py: 1.2,
                                minWidth: 200,
                            }}>
                                <Stack direction="row" spacing={1} alignItems="center" mb={0.3}>
                                    <AutoAwesomeIcon sx={{ color: "#A78BFA", fontSize: 16 }} />
                                    <Typography sx={{ color: "#A78BFA", fontSize: 13, fontWeight: 700 }}>
                                        Building Your Assets
                                    </Typography>
                                </Stack>
                                <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: 11.5 }}>
                                    AI is working in the background
                                </Typography>
                            </Box>
                        </Stack>
                    </Box>

                    {/* ── PROGRESS SECTION ── */}
                    <Box sx={{
                        background: "linear-gradient(180deg, rgba(17,24,39,0.96) 0%, rgba(8,12,20,0.96) 100%)",
                        border: "1px solid rgba(255,255,255,0.06)",
                        borderRadius: "16px",
                        p: 3,
                    }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={3}>
                            <Box>
                                <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>
                                    Content Created From Your Uploads
                                </Typography>
                                <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: 13, mt: 0.3 }}>
                                    Hi {userDetails?.first_name || "there"} — we're turning everything you've shared into a complete set of assets.
                                </Typography>
                            </Box>
                        </Stack>

                        {/* Progress bar */}
                        <Box sx={{
                            p: 3,
                            borderRadius: "12px",
                            border: "1px solid rgba(75,165,235,0.3)",
                            background: "linear-gradient(135deg, rgba(37,99,235,0.08), rgba(56,189,248,0.03))",
                        }}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <AutoAwesomeIcon sx={{ color: "#4BA5EB", fontSize: 18 }} />
                                    <Typography sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>
                                        Course Generation in Progress
                                    </Typography>
                                </Stack>
                                <Typography sx={{ color: "#4BA5EB", fontSize: 18, fontWeight: 700 }}>
                                    {CJBprogress}%
                                </Typography>
                            </Stack>

                            <LinearProgress
                                variant="determinate"
                                value={CJBprogress}
                                sx={{
                                    height: 10,
                                    borderRadius: 6,
                                    backgroundColor: "rgba(255,255,255,0.06)",
                                    "& .MuiLinearProgress-bar": {
                                        background: "linear-gradient(90deg, #2563EB 0%, #38BDF8 100%)",
                                        borderRadius: 6,
                                    },
                                }}
                            />

                            <Typography sx={{ color: "rgba(255,255,255,0.5)", fontSize: 12.5, mt: 1.5 }}>
                                We'll email you as soon as everything is ready. In the meantime, feel free to hit Close and explore other features.
                            </Typography>
                        </Box>

                        {/* What's being created */}
                        <Box sx={{ mt: 3 }}>
                            <Typography sx={{ color: "rgba(255,255,255,0.7)", fontSize: 13, fontWeight: 600, mb: 1.5 }}>
                                What we're building for you:
                            </Typography>
                            <Stack spacing={1.2}>
                                {[
                                    "Full course modules with lessons and curriculum",
                                    "AI-narrated lessons using your cloned voice",
                                    "SEO-optimized blog posts from your content",
                                    "Short-form video clips for social platforms",
                                    "Social media captions and posts",
                                    "AI-generated thumbnails and visuals",
                                ].map((item, i) => (
                                    <Stack key={i} direction="row" spacing={1.5} alignItems="center" sx={{
                                        p: 1.2, borderRadius: "8px",
                                        background: "rgba(255,255,255,0.02)",
                                        border: "1px solid rgba(255,255,255,0.04)",
                                    }}>
                                        <Box sx={{
                                            width: 6, height: 6, borderRadius: "50%",
                                            background: CJBprogress > (i + 1) * 15 ? "#22C55E" : "#4BA5EB",
                                            flexShrink: 0,
                                        }} />
                                        <Typography sx={{
                                            color: "rgba(255,255,255,0.75)", fontSize: 13,
                                        }}>
                                            {item}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>
                        </Box>

                        {/* Action buttons */}
                        <Stack direction="row" justifyContent="flex-end" spacing={1.5} mt={3}>
                            <Button variant="outlined"
                                onClick={() => {
                                    localStorage.setItem('activeItem', 'blogs');
                                    navigate('/codegenie/generated-blogs');
                                }}
                                sx={{
                                    borderColor: "rgba(255,255,255,0.15)",
                                    color: "rgba(255,255,255,0.8)",
                                    textTransform: "none", borderRadius: "10px",
                                    px: 3, py: 1, fontSize: 13.5, fontWeight: 500,
                                    "&:hover": { borderColor: "rgba(255,255,255,0.3)", background: "rgba(255,255,255,0.04)" },
                                }}>
                                Close
                            </Button>

                            <Button variant="outlined"
                                onClick={handleCreateCourseStepPrevious}
                                sx={{
                                    borderColor: "rgba(255,255,255,0.15)",
                                    color: "rgba(255,255,255,0.8)",
                                    textTransform: "none", borderRadius: "10px",
                                    px: 3, py: 1, fontSize: 13.5, fontWeight: 500,
                                    "&:hover": { borderColor: "rgba(255,255,255,0.3)", background: "rgba(255,255,255,0.04)" },
                                }}>
                                Previous
                            </Button>

                            <Button
                                disabled={CJBprogress < 100}
                                onClick={handleCreateCourseStep2}
                                sx={{
                                    background: "linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)",
                                    color: "#fff", textTransform: "none", borderRadius: "10px",
                                    px: 3.5, py: 1, fontSize: 13.5, fontWeight: 600,
                                    "&:hover": { background: "linear-gradient(135deg, #6D28D9 0%, #5B21B6 100%)" },
                                    "&.Mui-disabled": {
                                        background: "rgba(255,255,255,0.06)",
                                        color: "rgba(255,255,255,0.3)",
                                    },
                                }}>
                                Done
                            </Button>
                        </Stack>
                    </Box>
                </Box>
            </Box>

            {/* ═══════════════ SUCCESS MODAL ═══════════════ */}
            {showSuccess && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <div style={{ fontSize: 48, marginBottom: 8 }}>🎉</div>
                        <h2 style={{ margin: "0 0 8px 0", color: "#fff", fontSize: 22 }}>Success!</h2>
                        <p style={{ marginBottom: 8, color: "rgba(255,255,255,0.75)", fontSize: 14 }}>
                            Your course was generated successfully.
                        </p>
                        <p style={{ marginBottom: 20, color: "rgba(255,255,255,0.55)", fontSize: 13 }}>
                            You can navigate to:
                        </p>

                        <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
                            <button
                                style={{ ...styles.primaryBtn, flex: 1 }}
                                onClick={() => {
                                    setShowSuccess(false);
                                    handleItemClick("course");
                                }}>
                                Course Listing
                            </button>

                            <button
                                style={{ ...styles.secondaryBtn, flex: 1 }}
                                onClick={() => {
                                    setShowSuccess(false);
                                    //handleItemClick("authority");
                                    localStorage.setItem("activeItem","authority");
                                    navigate("/codegenie/generated-blogs");
                                }}>
                                Authority Engine
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODALS */}
            <Modal open={openpaymentInstructModal}>
                <Box sx={{
                    position: "absolute", top: "50%", left: "50%",
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    transform: "translate(-50%, -50%)",
                    width: isMobile ? "95%" : 600,
                    bgcolor: "background.paper", border: "2px solid #000",
                    boxShadow: 24, pt: 2, px: 4, pb: 3,
                }}>
                    <PriorityHighIcon style={{ color: 'yellow', fontSize: '38px' }} />
                    <p style={{ textAlign: 'center' }}>Please make a payment to complete your process.</p>
                    <Stack flexDirection="row">
                        <Button onClick={() => setOpenPaymentInstructModal(false)}
                            variant="contained" sx={{ mr: 2 }}>Pay Now</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={upgradeModal} disableEscapeKeyDown>
                <Box sx={{
                    position: "absolute", top: "50%", left: "50%",
                    display: 'flex', flexDirection: 'column', alignItems: 'center',
                    transform: "translate(-50%, -50%)",
                    width: isMobile ? "95%" : "40%",
                    bgcolor: "background.paper", border: "2px solid #000",
                    boxShadow: 24, pt: 2, px: 4, pb: 3,
                    borderRadius: '15px', padding: '3%'
                }}>
                    <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        <InfoIcon sx={{ color: '#ffcc00' }} /><br />
                        This feature is not included in your plan. Please upgrade to access this feature.
                    </Typography>
                    <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>
                        <Button onClick={() => setUpgradeModal(false)} variant="contained">Close</Button>
                    </Stack>
                </Box>
            </Modal>
        </Box>
    );
};

export default New_Course_2;
